import api from "@/api/api";
import { STATUS_HTTP } from "@/api/statusHTTP";
import { iniciarRequisicao, logout } from "@/helpers";

const PREFIXO = '/compras/comparar-produtos';

export const buscarProdutoSelecionado = async (parametros) => {
  const url = `${PREFIXO}`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.itens;
}

export const compararProdutos = async (parametros) => {
  const url = `${PREFIXO}/comparar`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.itens;
}

export const removerProdutoComparacao = async (parametros) => {
  const url = `${PREFIXO}/remover-comparacao`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.itens;
}
